module.exports = __webpack_public_path__ + "img/pazuan.3e836e71.jpg";